import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { ICSend } from '../../../assets'
import { WalletContext } from '../../../context/walletContext'
import { Button } from '../../atoms'

export default function CardAction(props) {
  const [conWallet, setConWallet] = useState(false)
  const [btnTier, setBtnTier] = useState(false)
  const [btnBsc, setBtnBsc] = useState(false)
  const [btnOxbc, setBtnOxbc] = useState(false)

  const history = useHistory();

  const { isWalletConnect } = useContext(WalletContext)
  useEffect(() => {
    setConWallet(isWalletConnect)
  }, [isWalletConnect])

  const connectWallet = () => {
    setConWallet(true);
  }
  const changeWallet = (e) => {
    if (e.target.className.indexOf('tier') >= 0) {
      setBtnTier(true)
      setBtnBsc(false)
      setBtnOxbc(false)
    }
    if (e.target.className.indexOf('bsc') >= 0) {
      setBtnTier(false)
      setBtnBsc(true)
      setBtnOxbc(false)
    }
    if (e.target.className.indexOf('oxbc') >= 0) {
      setBtnTier(false)
      setBtnBsc(false)
      setBtnOxbc(true)
    }
  }

  const sayThank = () => {
    history.push('/interest')
  }

  const teleGroup = () => {
    const win = window.open(" https://t.me/deficandyio", "_blank");
    win.focus();
  }

  return (
    <div className="cardContainer">
      <div className="row">
        <div className="col-lg-2 col-5 px-1 px-lg-2">
          <Button label="Buy" varian="orange" onClick={sayThank} />
        </div>
        <div className="col-lg-2 col-5 px-1 px-lg-2">
          <Button label="Chart" varian="orange light" onClick={sayThank} />
        </div>
        <div className="col-lg-2 col-2 px-1 px-lg-2">
          <Button width={50} icon={ICSend} onClick={teleGroup} />
        </div>
        {
          !conWallet ?
            <div className="col-lg-6 mt-3 mt-lg-0 px-2 d-none">
              <Button label="Connect Wallet" varian="purple ms-auto wallet" onClick={connectWallet} />
            </div>
            :
            <div className="col-lg-6 mt-3 mt-lg-0 px-2 text-end">
              <div className="btn-group primary">
                <Button label="Tier 1" varian="child tier" active={btnTier} onClick={changeWallet} width={100} />
                <Button label="Bsc" varian="child bsc" active={btnBsc} onClick={changeWallet} width={100} />
                <Button label="Oxbc" varian="child oxbc" active={btnOxbc} onClick={changeWallet} width={100} />
              </div>
            </div>
        }
      </div>
    </div>
  )
}
